module.exports = __webpack_public_path__ + "static/img/logo.3947307.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo.png
// module id = vVZ4
// module chunks = 1